import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

export const AnimatedCounter = ({ end, suffix = "", prefix = "", label, duration = 2.5, darkMode = true }) => {
  const { ref, inView } = useInView({ threshold: 0.3, triggerOnce: true });

  return (
    <div ref={ref} className="text-left">
      <div className="flex items-baseline gap-1">
        {prefix && <span className="text-[#B8D86B] text-lg font-semibold">{prefix}</span>}
        <span className={`text-4xl md:text-5xl font-bold tracking-tight ${darkMode ? 'text-white' : 'text-neutral-900'}`} style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
          {inView ? <CountUp end={end} duration={duration} separator="," /> : "0"}
        </span>
        {suffix && <span className="text-[#B8D86B] text-2xl md:text-3xl font-bold">{suffix}</span>}
      </div>
      <p className={`text-sm mt-2 font-medium tracking-wide uppercase ${darkMode ? 'text-white/50' : 'text-neutral-500'}`}>{label}</p>
    </div>
  );
};
